<template>
  <div class="Fuell-Table">
    <div class="Fuell-Table--header">
      <div
        @click="sortCustomersByField('name')"
        class="Fuell-Table--item Fuell-Table--sortable"
      >
        <span v-t="{ path: 'customer_list_table_header_name' }"></span>
        <span
          class="sortable-handler"
          :class="getCustomerSortableClass('name')"
        ></span>
      </div>
      <div
        @click="sortCustomersByField('registrationNumber')"
        class="Fuell-Table--item Fuell-Table--sortable"
      >
        <span v-t="{ path: 'customer_list_table_header_registration_number' }"></span>
        <span
          class="sortable-handler"
          :class="getCustomerSortableClass('registrationNumber')"
        ></span>
      </div>
            <div

        class="Fuell-Table--item "
      >
        <span v-t="{ path: 'customer_onboarding_header' }"></span>
      </div>
      <div
        @click="sortCustomersByField('customerStatus.code')"
        class="Fuell-Table--item Fuell-Table--sortable"
      >
        <span v-t="{ path: 'STATUS' }"></span>
        <span
          class="sortable-handler"
          :class="getCustomerSortableClass('customerStatus.code')"
        ></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path : 'customer_creation_zoho_pricing_plan'}"></span>
      </div>
      <div
        class="Fuell-Table--item"
      >
        <span v-t="{ path: 'customer_list_table_header_customer_card_usage_type' }"></span>
        <span
          class="sortable-handler"
          :class="getCustomerSortableClass('customerType.name')"
        ></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'customer_list_table_header_customer_office_admin' }"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'customer_list_table_header_customer_office_admin_status' }"></span>
      </div>
      <div class="Fuell-Table--item"></div>
    </div>

    <div class="Fuell-Table--content">
      <user-customer-list-table-row
        :customer="customer"
        v-for="customer in customers"
        :key="customer.id"
        @showCustomerActionsModal="showCustomerActions"
      />
    </div>

    <div class="Fuell-Table--spinner" v-if="isCallingCustomers">
      <spinner></spinner>
    </div>
  </div>
</template>

<script>
import UserCustomerListTableRow from './UserCustomerListTableRow'
import _customersTableHandlerMixin from '../../_mixins/_customersTableHandlerMixin'
import _customersTableSortingMixin from '../../_mixins/_customersTableSortingMixin'

import _paginationHandlerMixin from '@/components/Commons/_mixins/_paginationHandlerMixin'
import Spinner from '@/components/Commons/Spinner'

export default {
  name: 'UserCustomerListTable',
  components: { UserCustomerListTableRow, Spinner },
  mixins: [
    _customersTableHandlerMixin,
    _customersTableSortingMixin,
    _paginationHandlerMixin
  ],
  methods: {
    fetchCustomers () {
      this.$store.dispatch('CustomersStore/fetchCustomers')
    },
    clearCustomers () {
      this.$store.dispatch('CustomersStore/clearStore')
    },
    showCustomerActions (event) {
      this.$emit('showCustomerActionsModal', event)
    }
  },
  created () {
    if (this.customers && this.customers.length > 0) {
      this.clearCustomers()
    }
    this.fetchCustomers()
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/tables/customers";
</style>
